<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>产线列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工厂名称" prop="factory_code">
                <el-select
                  v-model="searchform.factory_code"
                  filterable
                  style="width: 100%"
                  placeholder="请选择工厂"
                  @change="
                    getworkshoplistsearch(searchform.factory_code),
                      (searchform.factory_sub_code = null),
                      (searchform.workshop_uuid = null)
                  "
                >
                  <el-option
                    v-for="(item, index) in factorylist"
                    :key="index"
                    :label="item.factory_name"
                    :value="item.factory_code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="车间名称" prop="workshop_uuid">
                <el-select
                  v-model="searchform.workshop_uuid"
                  filterable
                  style="width: 100%"
                  placeholder="请选择车间"
                >
                  <el-option
                    v-for="(item, index) in workshoplist"
                    :key="index"
                    :label="item.workshop_name"
                    :value="item.workshop_uuid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产线编号" prop="workline_code">
                <el-input
                  v-model="searchform.workline_code"
                  style="width: 100%"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" style="margin-left: 10px">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['workline_select']"
                >搜索</el-button
              >
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="dialogVisible = true"
                v-permission="['workline_add']"
                >新建产线</el-button
              >
              <el-button
                v-permission="['workline_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
                >导出Excel</el-button
              >
            </el-col>
          </el-row>
        </el-form>
        <!-- <el-button
          :loading="downloadLoading"
          type="primary"
          icon="document"
          @click="handleDownload"
        >导出Excel</el-button>-->
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width: 90%"
            @cell-click="danhang"
          >
            <el-table-column
              prop="factory_name"
              label="工厂"
              min-width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="workshop_name"
              label="车间"
              min-width="250"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="workline_code"
              label="产线编号"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="workline_name"
              label="产线名称"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="action" label="操作" width="220">
              <el-button-group>
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="update"
                  v-permission="['workline_update']"
                  >修改</el-button
                >
                <el-button
                  type="danger"
                  plain
                  size="mini"
                  @click="deletedata"
                  v-permission="['workline_delete']"
                  >删除</el-button
                >
              </el-button-group>
            </el-table-column>
          </el-table>
          <br />
          <!-- 编辑修改出框 -->
          <el-dialog
            title="编辑"
            :visible.sync="editVisible"
            center
            width="30%"
          >
            <el-form
              :model="form"
              ref="form"
              label-width="100px"
              :rules="rules"
            >
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-select
                    v-model="form.factory_code"
                    style="width: 80%"
                    placeholder="请选择工厂"
                    @change="
                      getfactorysubchange(form.factory_code),
                        (form.factory_uuid = null),
                        (form.workshop_uuid = null)
                    "
                  >
                    <el-option
                      v-for="(item, index) in factorylist"
                      :key="index"
                      :label="item.factory_name"
                      :value="item.factory_code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="车间编号" prop="workshop_uuid">
                  <el-select
                    v-model="form.workshop_uuid"
                    style="width: 80%"
                    placeholder="请选择车间"
                  >
                    <el-option
                      v-for="(item, index) in workshoplistup"
                      :key="index"
                      :label="item.workshop_name"
                      :value="item.workshop_uuid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="产线编号" prop="workline_code">
                  <el-input
                    v-model="form.workline_code"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>

                <el-form-item label="产线名称" prop="workline_name">
                  <el-input
                    v-model="form.workline_name"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 新增弹出框 -->
          <el-dialog
            title="添加"
            :visible.sync="dialogVisible"
            @close="resetForm('formadd')"
            width="28%"
            :modal="true"
            center
          >
            <el-form
              :model="formadd"
              :rules="rules"
              ref="formadd"
              label-width="100px"
              style="margin-left: 15%"
            >
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-select
                    v-model="formadd.factory_code"
                    style="width: 80%"
                    placeholder="请选择工厂"
                    @change="
                      getfactorysubchange(formadd.factory_code),
                        (formadd.factory_uuid = null),
                        (formadd.workshop_uuid = null)
                    "
                  >
                    <el-option
                      v-for="(item, index) in factorylist"
                      :key="index"
                      :label="item.factory_name"
                      :value="item.factory_code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="车间编号" prop="workshop_uuid">
                  <el-select
                    v-model="formadd.workshop_uuid"
                    style="width: 80%"
                    placeholder="请选择车间"
                    @focus="judgefactory"
                  >
                    <el-option
                      v-for="(item, index) in workshoplistup"
                      :key="index"
                      :label="item.workshop_name"
                      :value="item.workshop_uuid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="产线编号" prop="workline_code">
                  <el-input
                    v-model="formadd.workline_code"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="产线名称" prop="workline_name">
                  <el-input
                    v-model="formadd.workline_name"
                    style="width: 80%"
                  ></el-input>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button @click="resetForm('formadd')">重置</el-button>
              <el-button type="primary" @click="submitadd('formadd')"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20, 30, 40, 50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  worklinelist,
  worklineadd,
  worklinedelete,
  worklineupdate,
  factorylist,
  workshoplist,
  listdistinct,
} from "@/api/plant";
export default {
  mounted() {
    //下拉
    listdistinct().then((response) => {
      this.factorylist = response.data;
      for (let i = 0; i < this.factorylist.length; i++) {
        this.factorylist[i].factory_name =
          this.factorylist[i].factory_code +
          "|" +
          this.factorylist[i].factory_name;
      }
    });
    workshoplist({
      factory_code: this.searchform.factory_code,
      pageSize: 1000,
    }).then((response) => {
      this.workshoplist = response.data.data;
      for (let i = 0; i < this.workshoplist.length; i++) {
        this.workshoplist[i].workshop_name =
          this.workshoplist[i].workshop_code +
          "|" +
          this.workshoplist[i].workshop_name;
      }
    });
    this.search();
  },
  activated() {
    this.searchform.workshop_uuid = this.$route.query.workshop_uuid;
    this.search();
  },
  data() {
    return {
      //基础数据
      dialogVisible: false,
      editVisible: false,
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      searchform: {
        factory_code: null,
        workshop_uuid: null,
        workshop_name: null,
        factory_sub_code: null,
        pageSize: null,
      },
      //获取下拉，post请求
      factory: {
        factory_uuid: null,
        factory_name: null,
        factory_code: null,
        factory_type: -1,
        factory_address: null,
      },
      factorysub: [],
      factorysublist: [],
      factorylist: [],
      workshop: {
        workshop_uuid: null,
        workshop_code: null,
        workshop_name: null,
        factory_uuid: null,
      },
      workshoplist: [],
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //修改表单数据
      form: {
        factory_code: null,
        workline_uuid: "",
        factory_uuid: "",
        workshop_uuid: "",
        workline_code: "",
        workline_name: "",
      },
      workshoplistup: [],
      //新增弹窗变量begin
      //表单数据
      formadd: {
        factory_code: null,
        factory_uuid: "",
        workshop_uuid: "",
        workline_code: "",
        workline_name: "",
      },
      workshoplistadd: [],
      //基础表单验证
      rules: {
        workshop_code: [
          { required: true, message: "请输入车间名称", trigger: "blur" },
        ],
        factory_code: [
          { required: true, message: "请输入工厂", trigger: "blur" },
        ],
        workline_code: [
          { required: true, message: "请输入产线编号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        workline_name: [
          { required: true, message: "请输入产线名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      worklinelist(obj).then((response) => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].factory_name =
            this.tableData[i].factory_code + this.tableData[i].factory_name;
          this.tableData[i].workshop_name =
            this.tableData[i].workshop_code + this.tableData[i].workshop_name;
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    getworkshoplistsearch(obj, obj2) {
      workshoplist({
        factory_code: obj,
        factory_sub_code: obj2,
        pageSize: 1000,
      }).then((response) => {
        //搜索车间下拉
        this.workshoplist = response.data.data;
        for (let i = 0; i < this.workshoplist.length; i++) {
          this.workshoplist[i].workshop_name =
            this.workshoplist[i].workshop_code +
            "|" +
            this.workshoplist[i].workshop_name;
        }
      });
    },
    getworkshoplistadd() {
      //新增车间下拉
      workshoplist({ factory_uuid: this.formadd.factory_uuid }).then(
        (response) => {
          this.workshoplistadd = response.data.data;
          for (let i = 0; i < this.workshoplistadd.length; i++) {
            this.workshoplistadd[i].workshop_name =
              this.workshoplistadd[i].workshop_code +
              "|" +
              this.workshoplistadd[i].workshop_name;
          }
        }
      );
    },
    judgefactory() {
      if (this.formadd.factory_uuid == "") {
        this.$message({
          message: "请先选择工厂",
          type: "warning",
        });
      }
    },
    //新增保存提示
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          worklineadd({
            factory_uuid: this.formadd.factory_uuid,
            workshop_uuid: this.formadd.workshop_uuid,
            workline_code: this.formadd.workline_code,
            workline_name: this.formadd.workline_name,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!",
              });
              this.resetForm(formName);
              this.Tabledata();
              console.log(this.formadd.account_status);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      worklinelist(this.searchform).then((response) => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].factory_name =
            this.tableData[i].factory_code + this.tableData[i].factory_name;
          this.tableData[i].workshop_name =
            this.tableData[i].workshop_code + this.tableData[i].workshop_name;
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.factorysublist = [];
      this.workshoplistup = [];
      this.factorysub = [];
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.currentPage = pageIndex;
      this.Tabledata({
        factory_code: this.searchform.factory_code,
        workshop_uuid: this.searchform.workshop_uuid,
        workshop_name: this.searchform.workshop_name,
        factory_sub_code: this.searchform.factory_sub_code,
        pageIndex: this.currentPage,
        pageSize: this.searchform.pageSize,
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    // 新增修改下拉
    getfactorysubchange(obj) {
      factorylist({ factoryCode: obj, pageSize: 1000 }).then((response) => {
        this.formadd.factory_uuid = response.data.data[0].factory_uuid;
        this.form.factory_uuid = response.data.data[0].factory_uuid;
        this.getworkshoplistchange(response.data.data[0].factory_uuid);
      });
    },
    getworkshoplistchange(obj) {
      this.form.workshop_uuid = null;
      workshoplist({ factory_uuid: obj, pageSize: 1000 }).then((response) => {
        this.workshoplistup = response.data.data;
        for (let i = 0; i < this.workshoplistup.length; i++) {
          this.workshoplistup[i].workshop_name =
            this.workshoplistup[i].workshop_code +
            "|" +
            this.workshoplistup[i].workshop_name;
        }
      });
    },
    //表格单行点击
    danhang(row) {
      this.form.factory_code = row.factory_code;
      this.form.workline_uuid = row.workline_uuid;
      this.form.factory_uuid = row.factory_uuid;
      this.form.workshop_uuid = row.workshop_uuid;
      this.form.workline_code = row.workline_code;
      this.form.workline_name = row.workline_name;
      workshoplist({ factory_uuid: row.factory_uuid, pageSize: 1000 }).then(
        (response) => {
          this.workshoplistup = response.data.data;
          for (let i = 0; i < this.workshoplistup.length; i++) {
            this.workshoplistup[i].workshop_name =
              this.workshoplistup[i].workshop_code +
              "|" +
              this.workshoplistup[i].workshop_name;
          }
        }
      );
      console.log(row);
    },
    // 修改按钮弹窗
    update() {
      setTimeout(() => {
        (this.requestnum = "1"), (this.editVisible = true); //弹窗false关闭 true开启
      }, 100);
    },
    // 修改弹窗保存       请求接口！！
    submit() {
      this.editVisible = false;
      worklineupdate({
        workline_uuid: this.form.workline_uuid,
        factory_uuid: this.form.factory_uuid,
        workshop_uuid: this.form.workshop_uuid,
        workline_code: this.form.workline_code,
        workline_name: this.form.workline_name,
      }).then((response) => {
        if (response.status_code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.currentchange(this.currentPage);
        } else {
          this.$message({
            type: "woring",
            message: "修改失败!请检查字段",
          });
        }
      });
    },
    //删除按钮事件
    deletedata() {
      this.$confirm("此操作将永久删除该产线信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          worklinedelete({
            workline_uuid: this.form.workline_uuid,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        factory_code: this.searchform.factory_code,
        workshop_uuid: this.searchform.workshop_uuid,
        workshop_name: this.searchform.workshop_name,
        factory_sub_code: this.searchform.factory_sub_code,
      };
      worklinelist(obj).then((response) => {
        this.tableDataDownload = response.data.data;
        for (let i = 0; i < this.tableDataDownload.length; i++) {
          this.tableDataDownload[i].factory_name =
            this.tableDataDownload[i].factory_code +
            this.tableDataDownload[i].factory_name;
          this.tableDataDownload[i].workshop_name =
            this.tableDataDownload[i].workshop_code +
            this.tableDataDownload[i].workshop_name;
        }

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工厂",
            "车间",
            "产线编号",
            "产线名称",
          ];
          const filterVal = [
            "factory_name",
            "workshop_name",
            "workline_code",
            "workline_name",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  },
};
</script>
<style scoped>
</style>
